/* ZIP SC: accessible help tooltips and in-cart Update/Cancel styling.
   Decorative changes only; no modification to selection, price, cart data or events. */
(function () {
  "use strict";
  var activeTooltip = null;
  var queued = false;
  function hideTooltip() {
    if (!activeTooltip) return;
    activeTooltip.classList.remove("zs-sc-tooltip-open");
    activeTooltip.setAttribute("aria-expanded", "false");
    activeTooltip = null;
  }
  function openTooltip(el) {
    if (activeTooltip === el) { hideTooltip(); return; }
    hideTooltip();
    activeTooltip = el;
    el.classList.add("zs-sc-tooltip-open");
    el.setAttribute("aria-expanded", "true");
  }
  function wireHelp() {
    document.querySelectorAll(".bold_options .bold_tooltip").forEach(function (el) {
      if (el.dataset.zsHelpReady) return;
      el.dataset.zsHelpReady = "true";
      el.setAttribute("tabindex", "0");
      el.setAttribute("role", "button");
      el.setAttribute("aria-label", "Show option information");
      el.setAttribute("aria-expanded", "false");
      el.addEventListener("click", function (event) {
        if (el.firstElementChild && el.firstElementChild.contains(event.target)) return;
        event.stopPropagation();
        event.preventDefault();
        openTooltip(el);
      });
      el.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          openTooltip(el);
        }
        if (event.key === "Escape") hideTooltip();
      });
    });
  }
  function buttonText(el) {
    return ((el.value && /^(button|submit)$/i.test(el.type)) ? el.value : el.textContent || "")
      .replace(/\s+/g, " ").trim().toLowerCase();
  }
  function markCartButtons() {
    if (!document.body.classList.contains("template-cart")) return;
    document.querySelectorAll(".bold_edit_in_cart, #bold-cart-modal").forEach(function (root) {
      var controls = Array.prototype.slice.call(
        root.querySelectorAll("button, input[type='button'], input[type='submit'], a")
      );
      var update = controls.find(function (el) { return buttonText(el) === "update"; });
      var cancel = controls.find(function (el) { return buttonText(el) === "cancel"; });
      if (!update || !cancel) return;
      update.classList.add("zs-sc-cart-update");
      cancel.classList.add("zs-sc-cart-cancel");
      if (update.parentElement === cancel.parentElement) {
        var parent = update.parentElement;
        if (!parent.querySelector(".bold_options, select, textarea") && parent.children.length <= 4) {
          parent.classList.add("zs-sc-cart-actions");
        }
      } else if (update.parentElement && cancel.parentElement &&
                 update.parentElement.parentElement === cancel.parentElement.parentElement) {
        var common = update.parentElement.parentElement;
        if (!common.querySelector(".bold_options, select, textarea") && common.children.length <= 4) {
          update.parentElement.classList.add("zs-sc-cart-action-wrap");
          cancel.parentElement.classList.add("zs-sc-cart-action-wrap");
          common.classList.add("zs-sc-cart-actions");
        }
      }
    });
  }
  function apply() {
    queued = false;
    wireHelp();
    markCartButtons();
  }
  function queue() {
    if (queued) return;
    queued = true;
    window.setTimeout(apply, 80);
  }
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".bold_tooltip")) hideTooltip();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") hideTooltip();
  });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", queue);
  else queue();
  var observer = new MutationObserver(queue);
  observer.observe(document.documentElement, {childList:true, subtree:true});
})();